<template>
  <div>
    <contactForm />
  </div>
</template>

<script>
import contactForm from "../components/contactForm.vue";

export default {
  name: "contact",
  components: {
    contactForm: contactForm,
  },
};
</script>
